export enum ReportUpdateStatusEnum {
    Ok = 1, Late = 2
}